import type es from '../es/credits';

/** `credits` in English. Same keys as `es/credits.ts`, enforced by the type. */
const credits: typeof es = {
  nav: 'Assessments',

  chip: {
    left: (n: number) => (n === 1 ? '1 assessment left' : `${n} assessments left`),
    none: 'No assessments left',
    freeStart: (n: number) => `${n} free to start`,
    reserved: (n: number) => `${n} in progress`,
  },
  buy: 'Buy assessments',

  page: {
    scope: 'English assessments',
    title: 'Your English assessments',
    lede: 'Each assessment is a call of about 10 minutes with an AI interviewer and a report with the level. You are only charged when you get a level.',
    balance: 'Available',
    reserved: 'In progress',
    reservedNote: 'Requested and waiting for the call. If they expire or you cancel them, they go back to your balance.',
    freeNote: (n: number) => `You started with ${n} free.`,
    rules:
      'Requesting an assessment sets 1 aside. If the candidate does not call in time, you cancel it, or the call is too short for a level, it goes back to your balance. If the person already has a recent result, you get it right away and it counts as 1.',
    packsTitle: 'Buy more',
    pack: (n: number) => `${n} assessments`,
    perUnit: (price: string) => `${price} each`,
    payNote: 'One-time card payment on Stripe. The invoice arrives by email. Not a subscription.',
    buyPack: 'Buy',
    opening: 'Opening the payment',
    buyFailed: 'We could not open the payment. Try again in a minute.',
    returnWaiting: 'We got your payment. We are adding the assessments to your balance.',
    returnDone: (n: number) => `Done: we added ${n} assessments to your balance.`,
    returnSlow:
      'Your payment went through, but the assessments are not showing yet. Reload in a few minutes and, if they still do not show, write to support.',
    returnCanceled: 'You canceled the payment. Nothing was charged.',
    historyTitle: 'Activity',
    historyEmpty: 'No activity yet.',
    types: {
      grant_free: 'Free to start',
      purchase: 'Purchase',
      reserve: 'Assessment requested',
      consume: 'Assessment charged',
      release: 'Back to your balance',
      adjust: 'TBit adjustment',
      refund: 'Refund',
    },
    columns: { date: 'Date', movement: 'Activity', amount: 'Assessments' },
    paid: (price: string) => `You paid ${price}`,
    disabled: 'English assessments are not deducted from a balance right now.',
    loadError: 'We could not load your balance. Reload the page.',
    back: 'Back to candidates',
  },

  panel: {
    costNote: 'Uses 1 of your assessments. If there is no level, it goes back to your balance.',
    noCredits: 'You have no assessments left. Buy a pack to request this one.',
  },

  admin: {
    column: 'Assessments',
    open: 'Credits',
    title: (agency: string) => `Credits for ${agency}`,
    balance: 'Balance',
    ledgerSum: 'Ledger sum',
    outOfSync: 'The balance does not match the ledger. Tell engineering before adjusting.',
    reserved: 'Open reservations',
    adjustTitle: 'Manual adjustment',
    adjustCredits: 'Assessments (+ or -)',
    adjustNote: 'Note (required): why',
    adjustSave: 'Save adjustment',
    adjustInvalid: 'Enter a whole number other than zero and a note.',
    adjustFailed: (msg: string) => `Could not adjust: ${msg}`,
    entries: 'Entries',
    pending: 'not applied',
    close: 'Close',
    loadError: 'Could not load the credits.',
    revenue: 'English assessments sold',
    revenueNote: (packs: number, credits: number) => `${packs} ${packs === 1 ? 'pack' : 'packs'} · ${credits} assessments`,
  },
};

export default credits;
